/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from "react";
import CardNews from "./CardNews";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ButtonPrimary from "../../../../components/button/ButtonPrimary";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import { logEvent } from "../../../../functions/amplitude";
import PopupTitleRedirect from "../../PopupTitleRedirect";
import {
  setAcademiaData,
  setAcademiaHeaderUrl,
  setAcademiaSearch,
  setShowTitleRedirectPopup,
} from "../../../../redux/features/dataSlice";
import MenuPrimary from "../../../../components/menu/MenuPrimary";
import { useSearchParams } from "react-router-dom";

import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import AcademiaNews from "./AcademiaNews";
import { academiaDescription } from "../../../../constants";
import CustomLoader from "../../../../components/loader";
import { getConfig, searchAPI } from "../../../../apis";
import { axiosInstance } from "../../../../functions/axios";

export default function SectionNews(props) {
  const {
    title,
    data,
    info,
    ugc,
    bookmarkUrls,
    setBookmarkData,
    setSaveBookmarkPopup,
  } = props;
  const cardScrollRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    search,
    showTitleRedirect,
    academiaSearch,
    academiaSearchList,
    academiaData,
  } = useSelector((state) => state.data);

  const [leftArrowVisible, setleftArrowVisible] = useState(false);
  const [rightArrowVisible, setrightArrowVisible] = useState(true);
  const [summaryAvailable, setSummaryAvailable] = useState(false);
  const [citationAvailable, setCitationAvailable] = useState(false);

  const [label, setLabel] = useState("Try This!");

  const [infoPopup, setinfoPopup] = useState(false);
  const [loading, setloading] = useState(false);

  const { query } = useParams();
  const { user } = useSelector((state) => state.auth);
  let [searchParams] = useSearchParams();

  const scrollTable = (direction) => {
    if (direction === "left") {
      cardScrollRef.current.scrollLeft -= 500;
    }
    if (direction === "right") {
      cardScrollRef.current.scrollLeft += 500;
    }
  };

  const handleRightClick = () => {
    const updatedClicks = Number(sessionStorage.getItem("clicks")) + 1;
    sessionStorage.setItem("clicks", updatedClicks.toString());

    if (updatedClicks === 3) {
      dispatch(setShowTitleRedirectPopup({ popup: true, title: title }));
    }
  };

  const getAcademiaData = async (item) => {
    try {
      setloading(true);
      let academiaDataObj = {};
      if (item.academiaId_ids !== 6) {
        const res = await axiosInstance.post(
          searchAPI.academiaSearch,
          {
            query: query,
            limit: "10",
            offset: "0",
            userId: user.userId,
            academiaId: item.academiaId_ids,
          },
          getConfig()
        );
        const arr = res.data.data;

        academiaDataObj = {
          [item.categoryName_chr]: arr,
        };
      }
      dispatch(setAcademiaData(academiaDataObj));
    } catch (e) {
      console.log(e);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const slider = cardScrollRef.current;
    function getScrollPos(e) {
      if (slider.scrollLeft === 0) {
        setleftArrowVisible(false);
        setrightArrowVisible(true);
      } else if (
        slider.offsetWidth + slider.scrollLeft >=
        slider.scrollWidth - 10
      ) {
        setrightArrowVisible(false);
      } else {
        setleftArrowVisible(true);
        setrightArrowVisible(true);
      }
    }

    if (slider) {
      slider.addEventListener("scroll", getScrollPos);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      if (slider) {
        slider.removeEventListener("scroll", getScrollPos);
      }
    };
  }, []);

  const isSummaryAvailable = () => {
    const summaryAvailable = academiaSearchList.filter(
      (option) => option.categoryName_chr === academiaSearch
    )[0]?.isSummaryAvailable_ysn;
    setSummaryAvailable(summaryAvailable);
  };

  const isCitationAvailable = () => {
    const citationAvailable = academiaSearchList.filter(
      (option) => option.categoryName_chr === academiaSearch
    )[0]?.isCitationAvailable_ysn;
    setCitationAvailable(citationAvailable);
  };

  useEffect(() => {
    if (title === "Academia") {
      console.log(academiaSearch === "Academia");
      if (academiaSearch !== "Academia") {
        const label = academiaSearchList.filter(
          (academia) => academia.categoryName_chr === academiaSearch
        )[0];
        if (label.displayName_chr) {
          setLabel(label.displayName_chr);
        }
        const option = academiaSearchList.filter(
          (option) => option.categoryName_chr === academiaSearch
        )[0];
        // getAcademiaData(option);
      }
    }
  }, []);

  const urlConstruction = () => {
    const encodedQuery = encodeURIComponent(search);

    let url = `/category/${title}/${encodedQuery}`;

    const filter = searchParams.get("filter");

    if (title === "Academia") {
      url += `?type=${academiaSearch}`;
      if (filter) {
        if (academiaSearch === "Academia") {
          url += `&filter=${filter}`;
        }
      }
    } else {
      if (filter) {
        url += `?filter=${filter}`;
      }
    }
    return url;
  };

  const handleNewsCategoryRedirect = () => {
    localStorage.setItem("category", JSON.stringify(data));
    localStorage.setItem("academiaSearch", academiaSearch);
    localStorage.setItem("ugc", JSON.stringify(ugc));

    const url = urlConstruction();
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (title === "Academia") {
      isSummaryAvailable();
      isCitationAvailable();
    }
  }, [academiaSearch]);

  return (
    <div className="section-news" id={title}>
      <div className="flex">
        <Tooltip title="What is this category?">
          <InfoOutlinedIcon
            style={{
              fontSize: "1.5rem",
              cursor: "pointer",
              color: "var(--color-grey)",
            }}
            onClick={() => setinfoPopup(true)}
          />
        </Tooltip>
        <div
          className="header-link"
          onClick={() => {
            handleNewsCategoryRedirect();
          }}
        >
          <Tooltip title="Click to open full page of results from this category">
            <h3>
              {title === "Academia" ? "Academia & Scholarly Resources" : title}
            </h3>
          </Tooltip>
          <ArrowOutwardIcon className="mr-5" />
          {title === "Academia" && (
            <MenuPrimary
              data={academiaSearchList.map((option) => ({
                name: option.displayName_chr,
                onClick: () => {
                  getAcademiaData(option);
                  dispatch(setAcademiaSearch(option.categoryName_chr));
                  dispatch(setAcademiaHeaderUrl(option.hostName_chr));
                  setLabel(option.displayName_chr);
                },
              }))}
              children={
                <div className="flex">
                  <p>{label}</p>
                  <KeyboardArrowDownOutlinedIcon />
                </div>
              }
            />
          )}
        </div>
        <p> </p>
        {ugc && <p className="ugc">{ugc}</p>}
        {title === "Academia" && label !== "Academia" && (
          <p className="ugc">{academiaDescription(academiaSearch)}</p>
        )}
      </div>
      <div className="cards">
        <div className="content" ref={cardScrollRef}>
          {title === "Academia" && academiaSearch !== "Academia" && loading && (
            <div style={{ width: "100%" }}>
              <CustomLoader height="20rem" />
            </div>
          )}
          {data?.length
            ? data.map((item) =>
                title !== "Academia" ? (
                  <CardNews
                    key={item.id}
                    data={item}
                    bookmarkUrls={bookmarkUrls}
                    setBookmarkData={setBookmarkData}
                    setSaveBookmarkPopup={setSaveBookmarkPopup}
                    sectionTitle={title}
                  />
                ) : (
                  data.map((item) =>
                    title !== "Academia" ? (
                      <CardNews
                        key={item.id}
                        data={item}
                        bookmarkUrls={bookmarkUrls}
                        setBookmarkData={setBookmarkData}
                        setSaveBookmarkPopup={setSaveBookmarkPopup}
                        sectionTitle={title}
                      />
                    ) : // Code for the else condition, if any
                    academiaSearch === "Academia" ? (
                      <CardNews
                        key={item.id}
                        data={{
                          ...item,
                          charityNavigatorRating: null,
                          charityNavigatorScore: null,
                        }}
                        bookmarkUrls={bookmarkUrls}
                        setBookmarkData={setBookmarkData}
                        setSaveBookmarkPopup={setSaveBookmarkPopup}
                        sectionTitle={title}
                      />
                    ) : (
                      !loading && (
                        <AcademiaNews
                          key={item.id}
                          data={item}
                          bookmarkUrls={bookmarkUrls}
                          setBookmarkData={setBookmarkData}
                          setSaveBookmarkPopup={setSaveBookmarkPopup}
                          sectionTitle={title}
                          academiaSearch={academiaSearch}
                          label={academiaSearch}
                          summaryAvailable={summaryAvailable}
                          citationAvailable={citationAvailable}
                        />
                      )
                    )
                  )
                )
              )
            : !(title === "Academia" && loading) && (
                <div className="no-res">
                  <p>No results found</p>
                </div>
              )}
        </div>
        {leftArrowVisible && (
          <div className="arrow-left hd-mb">
            <div
              className="arrow-icon"
              onClick={() => {
                scrollTable("left");
                logEvent("click_resultset_backward", {
                  "back-arrow": "clicked",
                });
              }}
            >
              <ArrowBackIcon />
            </div>
          </div>
        )}

        {data?.length
          ? rightArrowVisible && (
              <div className="arrow-right hd-mb">
                {showTitleRedirect.popup &&
                  showTitleRedirect.title === title && (
                    <div className="popup-title">
                      <PopupTitleRedirect title={title} search={search} />
                    </div>
                  )}
                <div
                  className="arrow-icon"
                  onClick={() => {
                    scrollTable("right");
                    logEvent("click_resultset_forward", {
                      "front-arrow": "clicked",
                    });
                    handleRightClick();
                  }}
                >
                  <ArrowForwardIcon className="fas fa-arrow-right" />
                </div>
              </div>
            )
          : null}
      </div>

      {infoPopup && (
        <div className="popover-info">
          <div className="bg-dark" />

          <div className="info-popup">
            <CloseIcon className="cross" onClick={() => setinfoPopup(false)} />

            <h3 className="mb-2">{title}</h3>
            <p className="mb-2">{info}</p>
            <ButtonPrimary text="Close" onClick={() => setinfoPopup(false)} />
          </div>
        </div>
      )}
    </div>
  );
}
